import { useState, useEffect } from "react";
import CardProduct from "../components/CardProduct/CardProduct";
import CarrosselAvaliacoes from "./carrossel-avaliacoes/carrossel-avaliacoes";
import { Bannerpromo } from "../components/Bannerpromo/Bannerpromo";
import TitlePage from "../components/TitlesPages/TitlesPages";
import { productsServices } from "../services/productsServices";
import ProductFilter from "../components/FilterProduct/FilterProduct";

function Home() {
  const [productsDestaque, setProductsDestaque] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [page, setPage] = useState(1);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        const responsePD = await productsServices.getProductsByDestaque({
          page,
          itemsPerPage: 12,
        });
        setProductsDestaque(responsePD.data);
        setFilteredProducts(responsePD.data);
        setTotalPages(responsePD.pagination?.totalPages || 1);
        console.log("Produtos em destaque:", responsePD.data);
      } catch (error) {
        console.error("Erro ao buscar produtos em destaque:", error);
        setError(error);
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, [page]);

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  if (loading) {
    return <div>Carregando...</div>;
  }

  if (error) {
    return <div className="mmb:mt-48 smb:mt-44 xmb:mt-44 Iphones:mt-44 Iphones2:mt-44 lg:mt-32 xl:mt-44">Erro ao buscar produtos recentes: {error.message}</div>;
  }

  return (
    <>
      <Bannerpromo />
      <div className="mmb:ml-0 md:ml-32 lg:ml-52 2xl:ml-80">
        <TitlePage title="destaques" />
      </div>

      <div className="flex flex-col md:flex-row gap-4 px-1 md:px-0 md:gap-4 xl:px-4 xl:gap-4">
        {/* Sidebar de filtros */}
        <div className="w-full md:w-1/6 h-fit sticky top-20 z-10 self-start">
          <div className="bg-white p-4 rounded-lg shadow-md">
            <ProductFilter
              products={productsDestaque}
              updateFilteredProducts={setFilteredProducts}
            />
          </div>
        </div>

        {/* Área dos cards */}
        <div className="w-full md:w-4/5">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4 justify-items-center">
            {filteredProducts.map((product) => (
              <CardProduct key={product.id} product={product} />
            ))}
          </div>
        </div>
      </div>

      <div className="flex justify-center my-6 gap-4">
        <button
          disabled={page === 1}
          onClick={() => handlePageChange(page - 1)}
          className="bg-gray-200 px-4 py-2 rounded disabled:opacity-50">
          Anterior
        </button>

        <span className="px-4 py-2">
          {page} / {totalPages}
        </span>

        <button
          disabled={page === totalPages}
          onClick={() => handlePageChange(page + 1)}
          className="bg-gray-200 px-4 py-2 rounded disabled:opacity-50">
          Próxima
        </button>
      </div>

      <CarrosselAvaliacoes />
    </>
  );
}

export default Home;
